// extracted by mini-css-extract-plugin
export var noSpinners = "_mu-6";
export var percentageInput = "_mu-7";
export var variantColor1 = "_mu-0";
export var variantColor2 = "_mu-1";
export var variantColor3 = "_mu-2";
export var variantColor4 = "_mu-3";
export var variantColor5 = "_mu-4";
export var variantColor6 = "_mu-5";